interface ICompanyDetails {
  title: string;
  value: string;
}

const CompanyDetails = ({ title, value }: ICompanyDetails) => {
  return (
    <div className="detail">
      <h3>{title}</h3>
      <span>{value}</span>
    </div>
  );
};

export default CompanyDetails;
